import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import useIsOffline from "@ext/errorHandlers/hooks/useIsOffline";
import RepositoryBroken from "@ext/git/actions/RepositoryBroken";
import getCommitOidFromPathname from "@ext/git/actions/Revisions/logic/utils/getCommitOidFromPathname";
import Sync from "@ext/git/actions/Sync/components/Sync";
import t from "@ext/localization/locale/translate";
import { useIsStorageConnected } from "@ext/storage/logic/utils/useStorage";
import { GlassToolbar, GlassToolbarButton, GlassToolbarIcon, GlassToolbarSeparator } from "@ui-kit/GlassToolbar";
import ConnectStorageToolbar from "./ConnectStorageToolbar";
import { OfflineButton } from "./OfflineButton";
import PublishButton from "./PublishButton";

const LeftNavigationBottom = () => {
	const isOffline = useIsOffline();
	const { isNext } = usePlatform();
	const { isReadOnly } = PageDataContextService.value.conf;
	const isStorageConnected = useIsStorageConnected();
	const { catalogName, repositoryError } = useCatalogPropsStore(
		(state) => ({ catalogName: state.data?.name, repositoryError: state.data?.repositoryError }),
		"shallow",
	);
	const isRevision = !!getCommitOidFromPathname(catalogName);
	const isPublishDisabled = isOffline || (!isNext && isReadOnly);
	const publishDisabledReason = isRevision ? t("git.publish.error.at-revision") : t("git.publish.error.main-branch");
	const actionsToolbar = (
		<GlassToolbar className={isNext ? "w-fit" : "w-fit pr-1"} variant={isNext ? "single" : "default"}>
			<Sync disable={isOffline} />
			{!isNext && (
				<>
					<GlassToolbarSeparator />
					<PublishButton
						disable={isPublishDisabled}
						disabledReason={
							isOffline
								? t("disabled-reason.publish-offline")
								: !isNext && isReadOnly
									? publishDisabledReason
									: undefined
						}
					/>
				</>
			)}
		</GlassToolbar>
	);

	return (
		<div className="flex items-center gap-2" data-qa="qa-status-bar" data-testid="left-navigation-bottom">
			{!isStorageConnected ? (
				<ConnectStorageToolbar />
			) : repositoryError ? (
				<GlassToolbar className="w-fit px-1">
					<RepositoryBroken
						error={repositoryError}
						trigger={
							<GlassToolbarButton aria-label={t("git.error.broken.tooltip")} focusable>
								<GlassToolbarIcon icon="cloud-alert" />
							</GlassToolbarButton>
						}
					/>
				</GlassToolbar>
			) : (
				actionsToolbar
			)}
			{isOffline && !isNext && (
				<GlassToolbar variant="single">
					<OfflineButton />
				</GlassToolbar>
			)}
		</div>
	);
};
export default LeftNavigationBottom;
